import type { Attachment } from "@services/drybulkCargoOperationsApi";

/**
 * DBCO-0030 - display name for an attachment: originalFileName, then the URL basename, then the type
 * (the same fallback Bay Hire uses).
 */
export const getAttachmentFileName = (
  attachment: Pick<Attachment, "attachmentType" | "documentUrl" | "originalFileName">,
): string => {
  if (attachment.originalFileName) return attachment.originalFileName;

  const basename = (attachment.documentUrl ?? "")
    .split("?")[0]
    .split("#")[0]
    .split("/")
    .filter(Boolean)
    .pop();
  if (basename) {
    try {
      return decodeURIComponent(basename);
    } catch {
      return basename;
    }
  }

  return attachment.attachmentType;
};
